<template>
  <div v-if="items.length">
    <Title class="mb-4">{{ category.title }}</Title>
    <div class="page-home-category-center">
      <ArticleCard
        v-for="({ id, title, img, category, date }, i) in items"
        :key="i"
        :id="id"
        :title="title"
        :img="img"
        :date="date"
        :category-title="category.title"
        :category-color="category.color"
        type="medium"
      ></ArticleCard>
    </div>
  </div>
</template>

<script>
import ArticleCard from "@/components/cards/article/Index.vue";
import Title from "@/components/widgets/Title.vue";

export default {
  data: () => ({
    items: [],
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    lg() {
      return this.$vuetify.breakpoint.lgAndDown;
    },
    category() {
      return this.$rest("articles-categories").list.find(
        ({ featured_home_center }) => featured_home_center === 1
      );
    },
    itemsPerPage() {
      if (this.xs) return 6;
      if (this.sm) return 4;
      if (this.md) return 9;
      if (this.lg) return 6;
      else return 6;
    },
  },
  methods: {
    get() {
      if (!this.category) return;

      const params = {
        itemsPerPage: this.itemsPerPage,
        category: this.category.id,
      };

      if (this.$route.query["data-atual"])
        params.todayDate = this.$route.query["data-atual"];

      this.$rest("articles")
        .get({ params })
        .then((data) => (this.items = data));
    },
  },
  watch: {
    category() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    ArticleCard,
    Title,
  },
};
</script>

<style>
.page-home-category-center {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media screen and (max-width: 960px) {
  .page-home-category-center {
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
